import{createContext as r}from"react";var a=r("small");export{a as CardSizeContext};
